/**
 * CORE-1266 — should a FAILED session-restore drop the stored token?
 *
 * On web boot the app restores the session by calling `/me` with the JWT read
 * from the cookie. The old bootstrap cleared the token on ANY failure of that
 * call. That was wrong, and it is what QA re-caught on prod:
 *
 * A direct hit on a path-alias route (`/recordings`, `/management/series`,
 * `/templates`) redirects via `window.location.replace(...)` the instant the
 * app mounts (see navigation/pathAliases + App.tsx). That replace tears the
 * current document down and ABORTS the `/me` request that init just started.
 * The abort is not an auth rejection — the cookie is still perfectly valid —
 * but the catch treated it as one and deleted the token. The very next load
 * (`/dashboard`) then read an empty cookie, saw a guest, and the dashboard
 * guard bounced the authorized master to `/login?returnTo=/me`. To the user it
 * read as «прямой заход сбрасывает авторизацию».
 *
 * The rule: only a DEFINITIVE auth rejection (a 401/403 that a refresh could
 * not rescue) means the stored session is actually dead. Everything else — a
 * network blip, an aborted request, a 5xx — is transient. Keep the token so the
 * next load can re-hydrate from it instead of turning a deep-link into a real
 * logout.
 */
export function isDefinitiveAuthFailure(error: unknown): boolean {
  const status = (error as { status?: number } | null | undefined)?.status;
  return status === 401 || status === 403;
}
